import { getNavLink } from '@/layout/NavLinks';
import * as React from 'react';
export default {
  getNavLink,
  React
};